package `fun`.adaptive.resource.file

object Files